import { Injectable, signal } from '@angular/core';
import { Binder } from 'src/app/models/binder.model';
import { MessageService } from 'primeng/api';
import { WaTaxService } from '../api/wa-tax.service';
import { Tax, TaxError } from '@/models/tax.model';

@Injectable({
  providedIn: 'root'
})
export class TaxDataService {
  taxData = signal<Tax>(new Tax());
  taxError = signal<TaxError>(new TaxError());

  currentAddress: string = '';
  currentZip: number = 0;
  currentCity: string = '';
  currentTaxResult: Tax =new Tax();

  constructor(
    private waTaxService: WaTaxService,
    private messageService: MessageService
    // private currentBinderService: CurrentBinderService
  ) { }

  clearTaxError() {
    this.taxError.set(new TaxError());
  }

  setTaxError(error: TaxError) {
    this.taxError.set(error);
  }

  successTax() {
    this.taxError.set(new TaxError());
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Tax data updated successfully'
    });
  }

  async getTax(newData: Binder) {

    if (newData.TaxOverride || newData.SiteState === 'AZ') {
      this.currentTaxResult.rate = newData.TaxRate || 0;
      this.currentTaxResult.loccode = Number(newData.Tax_Location) || 0;
      this.currentTaxResult.localrate = 0;
      this.currentTaxResult.code = 0;
      this.currentTaxResult.rateDetails.name = newData.County;
      this.successTax();
      
    } else {
      console.log('tax override or az', newData.TaxOverride, newData.SiteState)
      switch (newData.SiteState) {
        case 'WA':
          if (newData.SiteAddress && newData.SiteZip && (this.checkDifferences(newData) || !this.currentTaxResult)) {
            this.currentTaxResult = await this.lookupWaTax(newData.SiteAddress, newData.SiteZip, newData.SiteCity);
            if(this.currentTaxResult) {
              this.currentAddress = newData.SiteAddress;
              this.currentZip = newData.SiteZip;
              this.currentCity = newData.SiteCity;
              this.successTax();
            } else {
              this.taxError.set({
                showError: true,
                message: 'WA DOR failed to return a tax rate. try again by refreshing the page, or enter manually.'
              });
            }
          } else {
            console.log('no tax found', this.currentTaxResult)
            this.successTax();
          }
          break;
        case 'ID':
          this.currentTaxResult.rate = newData.TaxRate || 0;
          this.currentTaxResult.loccode = Number(newData.Tax_Location) || 0;
          this.currentTaxResult.localrate = 0;
          this.currentTaxResult.code = 0;
          this.currentTaxResult.rateDetails.name = newData.County;
          this.successTax();
          break;
        case 'OR':
          this.currentTaxResult.rate = 0;
          this.currentTaxResult.loccode = 0;
          this.currentTaxResult.localrate = 0;
          this.currentTaxResult.code = 0;
          this.currentTaxResult.rateDetails.name = newData.County;
          this.successTax();
          break;
        default:
          this.successTax();
          break;
      }
    }
    this.taxData.set(this.currentTaxResult);
    
    return this.currentTaxResult;
  }

  checkDifferences(newData: Binder) {
    // console.log('checkDifferences triggered in tax-model.service.ts', this.currentAddress, newData.SiteAddress, this.currentZip, newData.SiteZip, this.currentCity, newData.SiteCity)
    return this.currentAddress !== newData.SiteAddress || this.currentZip !== newData.SiteZip || this.currentCity !== newData.SiteCity
  }

  lookupWaTax(address: string, zip: number, city?: string): Promise<Tax> {
    return new Promise((resolve, reject) => {
      const tax = new Tax();
      this.waTaxService.lookupWaTax(address, zip, city).subscribe({
        next: (data) => {
        tax.rate = data.rate;
        tax.loccode = data.loccode;
        tax.localrate = data.localrate;
        tax.code = data.code;
          resolve(tax);
        },
        error: (error) => {
          console.error('Error fetching tax data:', error);
        tax.taxError = {
          showError: true,
          showDialog: true,
          message: 'WA DOR failed to return a tax rate. try again by refreshing the page, or enter manually.'
        };
          reject(error);
        }
      });
    });
  }
}
